import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import ModalDialogTitle from "../../common/ModalDialogTitle";
import SchoolUsers from "../../CcpSchool/CcpSchoolAccountProfile/inc/SchoolUsers";

const DistrictSchoolUsers = ({ open, onClose, schoolId }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <ModalDialogTitle onClose={onClose}>School Users</ModalDialogTitle>
      <DialogContent>
        <SchoolUsers schoolId={schoolId} />
      </DialogContent>
    </Dialog>
  );
};

export default DistrictSchoolUsers;
